export default __webpack_public_path__ + "static/media/arrow.74227c64.svg";